import React, { useContext, useEffect, useState } from 'react';

import DOMPurify from 'isomorphic-dompurify';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import UserContext from '@components/lpc/Context/User/UserContext';
import { personRoles } from '@models/PotModel/personRoles';
import { ROUTE } from '@services/http/Route';
import ObjectService from '@services/utils/ObjectService';

import css from './NeedKycBanner.module.scss';

type NeedKycBannerProps = {
    customClass?: string;
    hasPots?: boolean;
    fromPotsSectionPage?: boolean;
    fromProfileSectionPage?: boolean;
    personRole?: string;
};
const NeedKycBanner = ({
    customClass,
    hasPots,
    fromPotsSectionPage,
    personRole,
    fromProfileSectionPage,
}: NeedKycBannerProps) => {
    const [showKycHeader, setShowKycHeader] = useState<boolean>(false);

    const { t } = useTranslateLpc('lpc-home');
    const userContext = useContext(UserContext);
    const { userAccount } = userContext;

    useEffect(() => {
        if (ObjectService.hasContent(userAccount)) {
            if (fromPotsSectionPage || fromProfileSectionPage) {
                setShowKycHeader(hasPots && !userAccount.isKycOk);
            } else if (personRole) {
                setShowKycHeader(
                    !userAccount.isKycOk &&
                        (personRole == personRoles.ORGANISER || personRole == personRoles.BENEFICIARY),
                );
            } else {
                setShowKycHeader(!userAccount.isKycOk);
            }
        }
    }, [userAccount]);

    return (
        <>
            {showKycHeader && (
                <Text variant={'caption_01'} color={'txt-alert'} customClass={`${customClass || ''} ${css.kycHeader}`}>
                    <img
                        className={css.kycHeader__icon}
                        src="/front-static/icons/display/alert-triangle-outline.svg"
                        alt="alert"
                    />
                    <span
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(t('payment-options.kyc-header', { link: ROUTE.MY_DOCUMENTS })),
                        }}
                    />
                </Text>
            )}
        </>
    );
};

export default NeedKycBanner;
